export const getTemplate = async (token, templatename, user,  data) => {
  const rec = {templatename, user, data}
  const url = 'https://portal.ttpadvisory.co.uk:3556/api/email/tstGetEmailTemplate'
  try {
    const ret = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(rec)
    })
    if(ret.ok) {
      const json = await ret.json();
      return json;
    }
    return {status: false, data: null, err: 'Error Fetching Template'}
  }catch(err) {
    return {status: false, data: null,err: err.toString()}
  }
}

export const getUserEmailTemplates = async (token) => {
  const url = 'https://portal.ttpadvisory.co.uk:3556/api/email/listuseremailtemplates'
  try {
    const ret = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
    })
    if(ret.ok) {
      const json = await ret.json();
      return json;
    }
    return {status: false, data: null, err: 'Error Fetching User Email Template List'}
  }catch(err) {
    return {status: false, data: null,err: err.toString()}
  }
}

